import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AIProductsPage from './pages/AIProductsPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminProductFormPage from './pages/AdminProductFormPage';
import AdminConsultationsPage from './pages/AdminConsultationsPage';
import AdminDemoRequestsPage from './pages/AdminDemoRequestsPage';
import AdminContentStudioPage from './pages/AdminContentStudioPage';
import AdminCaseStudiesPage from './pages/AdminCaseStudiesPage';
import AdminCaseStudyFormPage from './pages/AdminCaseStudyFormPage';
import ManagedServicesPage from './pages/ManagedServicesPage';
import AIConsultingPage from './pages/AIConsultingPage';
import CloudModernizationPage from './pages/CloudModernizationPage';
import CloudConsultingPage from './pages/CloudConsultingPage';
import StaffAugmentationPage from './pages/StaffAugmentationPage';
import ZaatlyPage from './pages/ZaatlyPage';
import CloudRebuildPage from './pages/CloudRebuildPage';
import CaseStudyDetailPage from './pages/CaseStudyDetailPage';
import ProtectedRoute from './components/ProtectedRoute';
import ChatBubble from './components/ChatBubble';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';

const ScrollHandler = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace('#', ''));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 50);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return null;
};

// Hide the chat bubble on admin routes so it doesn't interfere with the dashboard.
const ChatBubbleGate = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return null;
  return <ChatBubble />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollHandler />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/ai-products" element={<AIProductsPage />} />
            <Route path="/managed-services" element={<ManagedServicesPage />} />
            <Route path="/ai-consulting" element={<AIConsultingPage />} />
            <Route path="/cloud-modernization" element={<CloudModernizationPage />} />
            <Route path="/cloud-consulting" element={<CloudConsultingPage />} />
            <Route path="/staff-augmentation" element={<StaffAugmentationPage />} />
            <Route path="/products/zaatly" element={<ZaatlyPage />} />
            <Route path="/products/cloudrebuild" element={<CloudRebuildPage />} />
            <Route path="/case-studies/:slug" element={<CaseStudyDetailPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboardPage /></ProtectedRoute>} />
            <Route path="/admin/products/new" element={<ProtectedRoute><AdminProductFormPage /></ProtectedRoute>} />
            <Route path="/admin/products/:id/edit" element={<ProtectedRoute><AdminProductFormPage /></ProtectedRoute>} />
            <Route path="/admin/consultations" element={<ProtectedRoute><AdminConsultationsPage /></ProtectedRoute>} />
            <Route path="/admin/demo-requests" element={<ProtectedRoute><AdminDemoRequestsPage /></ProtectedRoute>} />
            <Route path="/admin/content-studio" element={<ProtectedRoute><AdminContentStudioPage /></ProtectedRoute>} />
            <Route path="/admin/case-studies" element={<ProtectedRoute><AdminCaseStudiesPage /></ProtectedRoute>} />
            <Route path="/admin/case-studies/new" element={<ProtectedRoute><AdminCaseStudyFormPage /></ProtectedRoute>} />
            <Route path="/admin/case-studies/:id/edit" element={<ProtectedRoute><AdminCaseStudyFormPage /></ProtectedRoute>} />
          </Routes>
          <ChatBubbleGate />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
